/**
 * PageWrapper
 * Small component to consistently wrap the page content rendered inside SidebarLayout.props.children
 * @param props
 * @returns
 */
export function PageWrapper(props: { children: React.ReactNode }) {
    return (
        <>
            <div className="mx-6">{props.children}</div>
        </>
    );
}
